// extracted by mini-css-extract-plugin
module.exports = {"taboolaWrapper":"taboola_taboolaWrapper__pwWfj"};